// extracted by mini-css-extract-plugin
module.exports = {"messages-table":"messages-table_messages-table__1y2Rx","messages-table__title":"messages-table_messages-table__title__29c_x"};